// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
   MOBILE DASHBOARD - Responsive for all phones
   ============================================= */

* {
    -webkit-tap-highlight-color: transparent;
}

/* PWA Install Banner */
.pwa-install-banner {
    background: #2b6cb0;
    color: white;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: 10px;
    margin-bottom: 14px;
    box-shadow: 0 2px 8px rgba(49,130,206,0.3);
}

.pwa-banner-icon {
    font-size: 1.4rem;
    flex-shrink: 0;
}

.pwa-banner-text {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.pwa-banner-text strong {
    font-size: 0.85rem;
    font-weight: 700;
}

.pwa-banner-text span {
    font-size: 0.78rem;
    opacity: 0.88;
}

.pwa-banner-close {
    background: rgba(255,255,255,0.2);
    border: none;
    color: white;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    font-size: 0.85rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 0;
}

.mobile-dashboard {
    /* Safe area: top for notch/status bar, bottom for home indicator */
    padding: max(env(safe-area-inset-top, 16px), 16px) 16px 16px 16px;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    display: flex;
    flex-direction: column;
    background-color: #f0f4f8;
    overflow-x: hidden;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    box-sizing: border-box;
}

/* ---- HEADER ---- */
.dashboard-header {
    margin-bottom: 20px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.dashboard-logo {
    height: 36px;
    max-width: 120px;
    object-fit: contain;
    flex-shrink: 0;
}

.user-info {
    text-align: right;
    min-width: 0;
}

.user-info h1 {
    font-size: 1.05rem;
    color: #2d3748;
    margin: 0;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 170px;
}

.user-info p {
    display: none;
}

/* ---- SECTION TITLE ---- */
.section-title {
    text-align: center;
    font-size: 0.8rem;
    color: #718096;
    margin: 0 0 12px 0;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1.5px;
}

/* ---- GRID ---- */
.dashboard-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1 1;
}

/* ---- CARD ---- */
.mobile-dashboard-card {
    border: none;
    border-radius: 12px;
    padding: 13px 15px;
    display: flex;
    align-items: center;
    gap: 14px;
    cursor: pointer;
    transition: transform 0.15s, opacity 0.15s;
    position: relative;
    text-align: left;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    width: 100%;
    appearance: none;
    outline: none;
    box-sizing: border-box;
}

.mobile-dashboard-card:active {
    transform: scale(0.97);
    opacity: 0.9;
}

.mobile-dashboard-card.primary {
    background: linear-gradient(135deg, #3182ce 0%, #2563a8 100%);
    color: white;
}

.mobile-dashboard-card.secondary {
    background: white;
    color: #2d3748;
    border: 1px solid #e2e8f0;
}

/* ---- ICON ---- */
.mobile-dashboard-card .icon {
    font-size: 1.5rem;
    background: rgba(255, 255, 255, 0.22);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    flex-shrink: 0;
}

.mobile-dashboard-card.secondary .icon {
    background: #edf2f7;
}

/* ---- LABEL ---- */
.mobile-dashboard-card .label {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.2;
    flex: 1 1;
}

/* ---- BADGE ---- */
.mobile-dashboard-card .badge {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 14px;
    background: rgba(255,255,255,0.25);
    color: white;
    font-size: 0.7rem;
    padding: 3px 8px;
    border-radius: 20px;
    font-weight: 600;
    white-space: nowrap;
}

.mobile-dashboard-card.secondary .badge {
    background: #edf2f7;
    color: #718096;
}

/* ---- FOOTER ---- */
.dashboard-footer {
    margin-top: 20px;
    padding-bottom: 20px;
    padding-bottom: env(safe-area-inset-bottom, 20px);
}

.logout-btn-large {
    width: 100%;
    padding: 14px;
    background: #fed7d7;
    color: #c53030;
    border: none;
    border-radius: 12px;
    font-weight: 700;
    font-size: 0.95rem;
    cursor: pointer;
    appearance: none;
    transition: opacity 0.15s;
}

.logout-btn-large:active {
    opacity: 0.8;
}

/* =============================================
   SMALL / OLDER PHONES (max-width: 360px)
   e.g. Samsung Galaxy S5, older Androids
   ============================================= */
@media (max-width: 360px) {
    .mobile-dashboard {
        padding: 12px;
    }
    .dashboard-header {
        margin-bottom: 14px;
    }
    .dashboard-logo {
        height: 28px;
        max-width: 100px;
    }
    .user-info h1 {
        font-size: 0.9rem;
        max-width: 140px;
    }
    .dashboard-grid {
        gap: 8px;
    }
    .mobile-dashboard-card {
        padding: 11px 12px;
        gap: 11px;
        border-radius: 10px;
    }
    .mobile-dashboard-card .icon {
        width: 36px;
        height: 36px;
        font-size: 1.3rem;
    }
    .mobile-dashboard-card .label {
        font-size: 0.92rem;
    }
    .section-title {
        font-size: 0.72rem;
        letter-spacing: 1px;
    }
    .logout-btn-large {
        padding: 12px;
        font-size: 0.9rem;
    }
}

/* =============================================
   VERY SMALL SCREENS (max-width: 320px)
   e.g. iPhone SE 1st gen, old Androids
   ============================================= */
@media (max-width: 320px) {
    .mobile-dashboard {
        padding: 10px;
    }
    .dashboard-grid {
        gap: 7px;
    }
    .mobile-dashboard-card {
        padding: 10px 11px;
        gap: 10px;
    }
    .mobile-dashboard-card .icon {
        width: 32px;
        height: 32px;
        font-size: 1.15rem;
        border-radius: 8px;
    }
    .mobile-dashboard-card .label {
        font-size: 0.88rem;
    }
}

/* =============================================
   LANDSCAPE on small phones
   ============================================= */
@media (orientation: landscape) and (max-height: 480px) {
    .mobile-dashboard {
        padding: 8px 16px;
    }
    .dashboard-header {
        margin-bottom: 8px;
    }
    .section-title {
        margin-bottom: 6px;
    }
    .dashboard-grid {
        gap: 6px;
    }
    .mobile-dashboard-card {
        padding: 8px 14px;
    }
    .mobile-dashboard-card .icon {
        width: 32px;
        height: 32px;
        font-size: 1.2rem;
    }
    .dashboard-footer {
        margin-top: 10px;
    }
    .logout-btn-large {
        padding: 10px;
    }
}

/* Opções experimentais: renderizadas apenas para administradores. */
.mobile-appearance { margin: -4px 0 18px; }
.mobile-appearance-toggle { display: flex; align-items: center; gap: 8px; margin-left: auto; min-height: 40px; padding: 8px 13px; border: 1px solid #bad0e4; border-radius: 20px; background: #ffffff9e; color: #305578; font-size: 13px; cursor: pointer; }
.mobile-appearance-options { margin-top: 10px; padding: 15px; border: 1px solid #c4d7e8; border-radius: 18px; background: #f8fbffe6; color: #284a6f; }
.mobile-appearance-label { display: block; font-size: 12px; font-weight: 600; margin: 0 0 8px; }
.mobile-appearance-label:not(:first-child) { margin-top: 15px; }
.mobile-appearance-choices { display: flex; flex-wrap: wrap; gap: 6px; }
.mobile-appearance-choices button { min-height: 42px; padding: 9px 13px; border: 1px solid #b8cee2; border-radius: 11px; background: #ffffff80; color: #345573; cursor: pointer; }
.mobile-appearance-choices button[aria-pressed="true"] { background: #286db0; color: #fff; border-color: #286db0; }
.mobile-dashboard :is(.mobile-dashboard-card, .mobile-appearance-toggle, .mobile-appearance-choices button):focus-visible { outline: 3px solid #478fda; outline-offset: 3px; }
.mobile-dashboard[data-mobile-theme="claro"] { background: linear-gradient(155deg, #f8fbff, #e5eefb); }
.mobile-dashboard[data-mobile-theme="claro"] .mobile-dashboard-card.primary { background: #ffffffcf; color: #284d76; border: 1px solid #c7dbee; box-shadow: 0 4px 12px #2553850b; }
.mobile-dashboard[data-mobile-theme="claro"] .mobile-dashboard-card .icon { background: #d9e9facc; }
.mobile-dashboard[data-mobile-theme="liquido"] { background: radial-gradient(ellipse at 0 0, #b6d9fa, transparent 65%), linear-gradient(145deg, #dfebfa, #c9ddf5); }
.mobile-dashboard[data-mobile-theme="liquido"] .mobile-dashboard-card.primary { background: linear-gradient(125deg, #31566df5, #223e55f5); border: 1px solid #52738a; color: #f2f8fc; box-shadow: 0 5px 18px #19384c20, inset 0 1px #ffffff20; backdrop-filter: blur(16px); -webkit-backdrop-filter: blur(16px); }
.mobile-dashboard[data-mobile-theme="liquido"] .mobile-dashboard-card .icon { background: #c8e8fb14; border: 1px solid #aed6ee40; color: #bde8f7; }
.mobile-dashboard[data-mobile-view="icons"] .dashboard-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 22px 10px; align-items: start; }
.mobile-dashboard[data-mobile-view="icons"] .mobile-dashboard-card.primary { display: flex; flex-direction: column; gap: 9px; padding: 0 2px; background: none; border: none; box-shadow: none; color: #25415e; text-align: center; backdrop-filter: none; -webkit-backdrop-filter: none; border-radius: 16px; }
.mobile-dashboard[data-mobile-view="icons"] .mobile-dashboard-card .icon { width: 66px; height: 66px; border-radius: 19px; font-size: 31px; background: linear-gradient(145deg, #78b4ed, #397aca); box-shadow: 0 5px 12px #204d7824, inset 0 1px #ffffff85; border: 1px solid #ffffff75; }
.mobile-dashboard[data-mobile-view="icons"] .mobile-dashboard-card:nth-child(3n+2) .icon { background: linear-gradient(145deg, #a9beef, #697fc2); }
.mobile-dashboard[data-mobile-view="icons"] .mobile-dashboard-card:nth-child(3n) .icon { background: linear-gradient(145deg, #88c9e5, #4a92bb); }
.mobile-dashboard[data-mobile-view="icons"] .mobile-dashboard-card .label { font-size: 12px; font-weight: 600; line-height: 1.35; width: 100%; overflow-wrap: anywhere; }
.mobile-dashboard[data-mobile-view="icons"][data-mobile-theme="liquido"] .mobile-dashboard-card .icon { background: linear-gradient(135deg, #31566d, #223e55); border-color: #52738a; color: #bde8f7; backdrop-filter: blur(16px); -webkit-backdrop-filter: blur(16px); }
@media (min-width: 420px) {
    .mobile-dashboard[data-mobile-view="icons"] .dashboard-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }
}
@media (max-width: 340px) {
    .mobile-dashboard[data-mobile-view="icons"] .mobile-dashboard-card .icon { width: 58px; height: 58px; font-size: 28px; }
}

/* The mobile menu uses the same line icons and blue tones as the desktop. */
.mobile-dashboard .app-icon { display:block; flex-shrink:0; }
.mobile-appearance-choices button, .mobile-dashboard .logout-btn-large { display:flex; align-items:center; justify-content:center; gap:8px; }
.mobile-dashboard[data-mobile-theme="liquido"][data-mobile-view="list"] .mobile-dashboard-card { min-height:68px; }
.mobile-dashboard[data-mobile-theme="liquido"] .mobile-dashboard-card .label { font-weight:600; }
.mobile-dashboard[data-mobile-view="icons"] .mobile-dashboard-card .icon .app-icon { width:28px; height:28px; }
.mobile-dashboard[data-mobile-theme="liquido"] .pwa-install-banner { background:#2d5268; border:1px solid #52738a; box-shadow:0 3px 12px #19384c18; }
.mobile-dashboard[data-mobile-theme="liquido"] .logout-btn-large { background:#eaf3faad; color:#355b74; border:1px solid #9ab7cd; font-weight:600; }
.mobile-dashboard .logout-btn-large:focus-visible, .mobile-dashboard .pwa-banner-close:focus-visible { outline:3px solid #478fda; outline-offset:3px; }
@media (hover:hover) { .mobile-dashboard[data-mobile-theme="liquido"][data-mobile-view="list"] .mobile-dashboard-card:hover { background:linear-gradient(125deg,#3b627b,#2a4963); } }
`, "",{"version":3,"sources":["webpack://./src/pages/MobileDashboard.css"],"names":[],"mappings":"AAAA;;kDAEkD;;AAElD;IACI,wCAAwC;AAC5C;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,mEAAmE;IACnE,iEAAiE;IACjE,iBAAiB;IACjB,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,SAAO;AACX;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,WAAW;IAEX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,qCAAqC;IACrC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,SAAO;AACX;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,kCAAkC;IAClC,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,gBAAgB;IAChB,oBAAoB;IACpB,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IAEf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;;;kDAGkD;AAClD;IACI;QACI,aAAa;IACjB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,QAAQ;IACZ;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,iBAAiB;IACrB;AACJ;;AAEA;;;kDAGkD;AAClD;IACI;QACI,aAAa;IACjB;IACA;QACI,QAAQ;IACZ;IACA;QACI,kBAAkB;QAClB,SAAS;IACb;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;;kDAEkD;AAClD;IACI;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,QAAQ;IACZ;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA,oEAAoE;AACpE,qBAAqB,mBAAmB,EAAE;AAC1C,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE;AAC3P,6BAA6B,gBAAgB,EAAE,aAAa,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACrJ,2BAA2B,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC/F,6CAA6C,gBAAgB,EAAE;AAC/D,6BAA6B,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AACvE,oCAAoC,gBAAgB,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE,eAAe,EAAE;AACjL,yDAAyD,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAClH,4HAA4H,0BAA0B,EAAE,mBAAmB,EAAE;AAC7K,+CAA+C,qDAAqD,EAAE;AACtG,8EAA8E,qBAAqB,EAAE,cAAc,EAAE,yBAAyB,EAAE,gCAAgC,EAAE;AAClL,4EAA4E,qBAAqB,EAAE;AACnG,iDAAiD,gHAAgH,EAAE;AACnK,gFAAgF,yDAAyD,EAAE,yBAAyB,EAAE,cAAc,EAAE,uDAAuD,EAAE,2BAA2B,EAAE,mCAAmC,EAAE;AACjT,8EAA8E,qBAAqB,EAAE,2BAA2B,EAAE,cAAc,EAAE;AAClJ,8DAA8D,aAAa,EAAE,gDAAgD,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACnK,6EAA6E,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,cAAc,EAAE,gBAAgB,EAAE,YAAY,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,6BAA6B,EAAE,mBAAmB,EAAE;AAC/S,2EAA2E,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE,qDAAqD,EAAE,uDAAuD,EAAE,2BAA2B,EAAE;AACzR,2FAA2F,qDAAqD,EAAE;AAClJ,yFAAyF,qDAAqD,EAAE;AAChJ,4EAA4E,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,WAAW,EAAE,uBAAuB,EAAE;AACxK,wGAAwG,qDAAqD,EAAE,qBAAqB,EAAE,cAAc,EAAE,2BAA2B,EAAE,mCAAmC,EAAE;AACxQ;IACI,8DAA8D,gDAAgD,EAAE;AACpH;AACA;IACI,2EAA2E,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AAC3H;;AAEA,4EAA4E;AAC5E,8BAA8B,aAAa,EAAE,aAAa,EAAE;AAC5D,yEAAyE,YAAY,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,OAAO,EAAE;AAC5I,iGAAiG,eAAe,EAAE;AAClH,+EAA+E,eAAe,EAAE;AAChG,qFAAqF,UAAU,EAAE,WAAW,EAAE;AAC9G,qEAAqE,kBAAkB,EAAE,wBAAwB,EAAE,+BAA+B,EAAE;AACpJ,mEAAmE,oBAAoB,EAAE,aAAa,EAAE,wBAAwB,EAAE,eAAe,EAAE;AACnJ,uGAAuG,yBAAyB,EAAE,kBAAkB,EAAE;AACtJ,uBAAuB,uGAAuG,kDAAkD,EAAE,EAAE","sourcesContent":["/* =============================================\n   MOBILE DASHBOARD - Responsive for all phones\n   ============================================= */\n\n* {\n    -webkit-tap-highlight-color: transparent;\n}\n\n/* PWA Install Banner */\n.pwa-install-banner {\n    background: #2b6cb0;\n    color: white;\n    padding: 10px 14px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    border-radius: 10px;\n    margin-bottom: 14px;\n    box-shadow: 0 2px 8px rgba(49,130,206,0.3);\n}\n\n.pwa-banner-icon {\n    font-size: 1.4rem;\n    flex-shrink: 0;\n}\n\n.pwa-banner-text {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n}\n\n.pwa-banner-text strong {\n    font-size: 0.85rem;\n    font-weight: 700;\n}\n\n.pwa-banner-text span {\n    font-size: 0.78rem;\n    opacity: 0.88;\n}\n\n.pwa-banner-close {\n    background: rgba(255,255,255,0.2);\n    border: none;\n    color: white;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    font-size: 0.85rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    padding: 0;\n}\n\n.mobile-dashboard {\n    /* Safe area: top for notch/status bar, bottom for home indicator */\n    padding: max(env(safe-area-inset-top, 16px), 16px) 16px 16px 16px;\n    min-height: 100vh;\n    min-height: -webkit-fill-available;\n    display: flex;\n    flex-direction: column;\n    background-color: #f0f4f8;\n    overflow-x: hidden;\n    width: 100%;\n    max-width: 600px;\n    margin: 0 auto;\n    box-sizing: border-box;\n}\n\n/* ---- HEADER ---- */\n.dashboard-header {\n    margin-bottom: 20px;\n}\n\n.header-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.dashboard-logo {\n    height: 36px;\n    max-width: 120px;\n    object-fit: contain;\n    flex-shrink: 0;\n}\n\n.user-info {\n    text-align: right;\n    min-width: 0;\n}\n\n.user-info h1 {\n    font-size: 1.05rem;\n    color: #2d3748;\n    margin: 0;\n    font-weight: 700;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 170px;\n}\n\n.user-info p {\n    display: none;\n}\n\n/* ---- SECTION TITLE ---- */\n.section-title {\n    text-align: center;\n    font-size: 0.8rem;\n    color: #718096;\n    margin: 0 0 12px 0;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n}\n\n/* ---- GRID ---- */\n.dashboard-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    flex: 1;\n}\n\n/* ---- CARD ---- */\n.mobile-dashboard-card {\n    border: none;\n    border-radius: 12px;\n    padding: 13px 15px;\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    cursor: pointer;\n    transition: transform 0.15s, opacity 0.15s;\n    position: relative;\n    text-align: left;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    -webkit-appearance: none;\n    appearance: none;\n    outline: none;\n    box-sizing: border-box;\n}\n\n.mobile-dashboard-card:active {\n    transform: scale(0.97);\n    opacity: 0.9;\n}\n\n.mobile-dashboard-card.primary {\n    background: linear-gradient(135deg, #3182ce 0%, #2563a8 100%);\n    color: white;\n}\n\n.mobile-dashboard-card.secondary {\n    background: white;\n    color: #2d3748;\n    border: 1px solid #e2e8f0;\n}\n\n/* ---- ICON ---- */\n.mobile-dashboard-card .icon {\n    font-size: 1.5rem;\n    background: rgba(255, 255, 255, 0.22);\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n    flex-shrink: 0;\n}\n\n.mobile-dashboard-card.secondary .icon {\n    background: #edf2f7;\n}\n\n/* ---- LABEL ---- */\n.mobile-dashboard-card .label {\n    font-size: 1rem;\n    font-weight: 700;\n    line-height: 1.2;\n    flex: 1;\n}\n\n/* ---- BADGE ---- */\n.mobile-dashboard-card .badge {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 14px;\n    background: rgba(255,255,255,0.25);\n    color: white;\n    font-size: 0.7rem;\n    padding: 3px 8px;\n    border-radius: 20px;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.mobile-dashboard-card.secondary .badge {\n    background: #edf2f7;\n    color: #718096;\n}\n\n/* ---- FOOTER ---- */\n.dashboard-footer {\n    margin-top: 20px;\n    padding-bottom: 20px;\n    padding-bottom: env(safe-area-inset-bottom, 20px);\n}\n\n.logout-btn-large {\n    width: 100%;\n    padding: 14px;\n    background: #fed7d7;\n    color: #c53030;\n    border: none;\n    border-radius: 12px;\n    font-weight: 700;\n    font-size: 0.95rem;\n    cursor: pointer;\n    -webkit-appearance: none;\n    appearance: none;\n    transition: opacity 0.15s;\n}\n\n.logout-btn-large:active {\n    opacity: 0.8;\n}\n\n/* =============================================\n   SMALL / OLDER PHONES (max-width: 360px)\n   e.g. Samsung Galaxy S5, older Androids\n   ============================================= */\n@media (max-width: 360px) {\n    .mobile-dashboard {\n        padding: 12px;\n    }\n    .dashboard-header {\n        margin-bottom: 14px;\n    }\n    .dashboard-logo {\n        height: 28px;\n        max-width: 100px;\n    }\n    .user-info h1 {\n        font-size: 0.9rem;\n        max-width: 140px;\n    }\n    .dashboard-grid {\n        gap: 8px;\n    }\n    .mobile-dashboard-card {\n        padding: 11px 12px;\n        gap: 11px;\n        border-radius: 10px;\n    }\n    .mobile-dashboard-card .icon {\n        width: 36px;\n        height: 36px;\n        font-size: 1.3rem;\n    }\n    .mobile-dashboard-card .label {\n        font-size: 0.92rem;\n    }\n    .section-title {\n        font-size: 0.72rem;\n        letter-spacing: 1px;\n    }\n    .logout-btn-large {\n        padding: 12px;\n        font-size: 0.9rem;\n    }\n}\n\n/* =============================================\n   VERY SMALL SCREENS (max-width: 320px)\n   e.g. iPhone SE 1st gen, old Androids\n   ============================================= */\n@media (max-width: 320px) {\n    .mobile-dashboard {\n        padding: 10px;\n    }\n    .dashboard-grid {\n        gap: 7px;\n    }\n    .mobile-dashboard-card {\n        padding: 10px 11px;\n        gap: 10px;\n    }\n    .mobile-dashboard-card .icon {\n        width: 32px;\n        height: 32px;\n        font-size: 1.15rem;\n        border-radius: 8px;\n    }\n    .mobile-dashboard-card .label {\n        font-size: 0.88rem;\n    }\n}\n\n/* =============================================\n   LANDSCAPE on small phones\n   ============================================= */\n@media (orientation: landscape) and (max-height: 480px) {\n    .mobile-dashboard {\n        padding: 8px 16px;\n    }\n    .dashboard-header {\n        margin-bottom: 8px;\n    }\n    .section-title {\n        margin-bottom: 6px;\n    }\n    .dashboard-grid {\n        gap: 6px;\n    }\n    .mobile-dashboard-card {\n        padding: 8px 14px;\n    }\n    .mobile-dashboard-card .icon {\n        width: 32px;\n        height: 32px;\n        font-size: 1.2rem;\n    }\n    .dashboard-footer {\n        margin-top: 10px;\n    }\n    .logout-btn-large {\n        padding: 10px;\n    }\n}\n\n/* Opções experimentais: renderizadas apenas para administradores. */\n.mobile-appearance { margin: -4px 0 18px; }\n.mobile-appearance-toggle { display: flex; align-items: center; gap: 8px; margin-left: auto; min-height: 40px; padding: 8px 13px; border: 1px solid #bad0e4; border-radius: 20px; background: #ffffff9e; color: #305578; font-size: 13px; cursor: pointer; }\n.mobile-appearance-options { margin-top: 10px; padding: 15px; border: 1px solid #c4d7e8; border-radius: 18px; background: #f8fbffe6; color: #284a6f; }\n.mobile-appearance-label { display: block; font-size: 12px; font-weight: 600; margin: 0 0 8px; }\n.mobile-appearance-label:not(:first-child) { margin-top: 15px; }\n.mobile-appearance-choices { display: flex; flex-wrap: wrap; gap: 6px; }\n.mobile-appearance-choices button { min-height: 42px; padding: 9px 13px; border: 1px solid #b8cee2; border-radius: 11px; background: #ffffff80; color: #345573; cursor: pointer; }\n.mobile-appearance-choices button[aria-pressed=\"true\"] { background: #286db0; color: #fff; border-color: #286db0; }\n.mobile-dashboard :is(.mobile-dashboard-card, .mobile-appearance-toggle, .mobile-appearance-choices button):focus-visible { outline: 3px solid #478fda; outline-offset: 3px; }\n.mobile-dashboard[data-mobile-theme=\"claro\"] { background: linear-gradient(155deg, #f8fbff, #e5eefb); }\n.mobile-dashboard[data-mobile-theme=\"claro\"] .mobile-dashboard-card.primary { background: #ffffffcf; color: #284d76; border: 1px solid #c7dbee; box-shadow: 0 4px 12px #2553850b; }\n.mobile-dashboard[data-mobile-theme=\"claro\"] .mobile-dashboard-card .icon { background: #d9e9facc; }\n.mobile-dashboard[data-mobile-theme=\"liquido\"] { background: radial-gradient(ellipse at 0 0, #b6d9fa, transparent 65%), linear-gradient(145deg, #dfebfa, #c9ddf5); }\n.mobile-dashboard[data-mobile-theme=\"liquido\"] .mobile-dashboard-card.primary { background: linear-gradient(125deg, #31566df5, #223e55f5); border: 1px solid #52738a; color: #f2f8fc; box-shadow: 0 5px 18px #19384c20, inset 0 1px #ffffff20; backdrop-filter: blur(16px); -webkit-backdrop-filter: blur(16px); }\n.mobile-dashboard[data-mobile-theme=\"liquido\"] .mobile-dashboard-card .icon { background: #c8e8fb14; border: 1px solid #aed6ee40; color: #bde8f7; }\n.mobile-dashboard[data-mobile-view=\"icons\"] .dashboard-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 22px 10px; align-items: start; }\n.mobile-dashboard[data-mobile-view=\"icons\"] .mobile-dashboard-card.primary { display: flex; flex-direction: column; gap: 9px; padding: 0 2px; background: none; border: none; box-shadow: none; color: #25415e; text-align: center; backdrop-filter: none; -webkit-backdrop-filter: none; border-radius: 16px; }\n.mobile-dashboard[data-mobile-view=\"icons\"] .mobile-dashboard-card .icon { width: 66px; height: 66px; border-radius: 19px; font-size: 31px; background: linear-gradient(145deg, #78b4ed, #397aca); box-shadow: 0 5px 12px #204d7824, inset 0 1px #ffffff85; border: 1px solid #ffffff75; }\n.mobile-dashboard[data-mobile-view=\"icons\"] .mobile-dashboard-card:nth-child(3n+2) .icon { background: linear-gradient(145deg, #a9beef, #697fc2); }\n.mobile-dashboard[data-mobile-view=\"icons\"] .mobile-dashboard-card:nth-child(3n) .icon { background: linear-gradient(145deg, #88c9e5, #4a92bb); }\n.mobile-dashboard[data-mobile-view=\"icons\"] .mobile-dashboard-card .label { font-size: 12px; font-weight: 600; line-height: 1.35; width: 100%; overflow-wrap: anywhere; }\n.mobile-dashboard[data-mobile-view=\"icons\"][data-mobile-theme=\"liquido\"] .mobile-dashboard-card .icon { background: linear-gradient(135deg, #31566d, #223e55); border-color: #52738a; color: #bde8f7; backdrop-filter: blur(16px); -webkit-backdrop-filter: blur(16px); }\n@media (min-width: 420px) {\n    .mobile-dashboard[data-mobile-view=\"icons\"] .dashboard-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n}\n@media (max-width: 340px) {\n    .mobile-dashboard[data-mobile-view=\"icons\"] .mobile-dashboard-card .icon { width: 58px; height: 58px; font-size: 28px; }\n}\n\n/* The mobile menu uses the same line icons and blue tones as the desktop. */\n.mobile-dashboard .app-icon { display:block; flex-shrink:0; }\n.mobile-appearance-choices button, .mobile-dashboard .logout-btn-large { display:flex; align-items:center; justify-content:center; gap:8px; }\n.mobile-dashboard[data-mobile-theme=\"liquido\"][data-mobile-view=\"list\"] .mobile-dashboard-card { min-height:68px; }\n.mobile-dashboard[data-mobile-theme=\"liquido\"] .mobile-dashboard-card .label { font-weight:600; }\n.mobile-dashboard[data-mobile-view=\"icons\"] .mobile-dashboard-card .icon .app-icon { width:28px; height:28px; }\n.mobile-dashboard[data-mobile-theme=\"liquido\"] .pwa-install-banner { background:#2d5268; border:1px solid #52738a; box-shadow:0 3px 12px #19384c18; }\n.mobile-dashboard[data-mobile-theme=\"liquido\"] .logout-btn-large { background:#eaf3faad; color:#355b74; border:1px solid #9ab7cd; font-weight:600; }\n.mobile-dashboard .logout-btn-large:focus-visible, .mobile-dashboard .pwa-banner-close:focus-visible { outline:3px solid #478fda; outline-offset:3px; }\n@media (hover:hover) { .mobile-dashboard[data-mobile-theme=\"liquido\"][data-mobile-view=\"list\"] .mobile-dashboard-card:hover { background:linear-gradient(125deg,#3b627b,#2a4963); } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
